import { addStyles } from 'ethcss'
import { colors, IStyles } from '../../../theme'
import grid from '../../../blocks.simple/grid/grid.jcss'

const modBusSettings: IStyles = {
    switchWrapper_: {
        display: 'flex',
        marginTop: 20,
    },
    switchCaption_: {
        display: 'flex',
        alignItems: 'center',
        marginLeft: 14,

        span: {
            marginRight: 6,
        },
    },
    wrapper: {
        marginTop: 21,
    },
    disabled: {
        opacity: 0.5,
    },
    radioButtons: {
        ...grid.row,
        ...grid.mb_md,
        ...grid.fullWidth,
    },
    border: {
        border: `1px solid ${colors.greyLight}`,
        padding: '10px',
        borderRadius: '10px',
    },
}

addStyles(modBusSettings)
export default modBusSettings
